export enum UserOrganizationalType {
	DIRECTOR = 'DIRECTOR',
	KAM = 'KAM',
	SUPERVISOR = 'SUPERVISOR',
	GENERAL = 'GENERAL',
}
